var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "box",
        [
          _c(
            "empty-state",
            {
              attrs: {
                title: _vm.Resources.BackerCenter.UpdatesFeedEmptyStateHeader,
                description:
                  _vm.Resources.BackerCenter.UpdatesFeedEmptyStateParagraph,
                "data-qa": "updates-feed-empty-state",
              },
            },
            [
              _c(
                "base-button",
                {
                  attrs: {
                    tag: "a",
                    theme: "accent",
                    href: _vm.searchUrl,
                    "data-qa": "updates-feed-empty-state:Reload",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.Resources.BackerCenter
                          .UpdatesFeedEmptyStateButtonLabel
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("backer-center-project-recommendations-section", {
        staticClass: "_mt-6",
        attrs: { "extra-large-screen-visible-items-count": 3 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }